module.exports = __webpack_public_path__ + "static/media/GCCLOGORED.4046dc26.png";